$(document).ready(function (){
  $('[href="#prevent"]').on('click', function (e) {
    e.preventDefault();
  })
})

const bottomLineElement = document.querySelector('.yotpo.bottomLine');

if (bottomLineElement) {
	bottomLineElement.addEventListener('click', function (event) {
		event.preventDefault();

		const targetElement = document.getElementById('yotpo-app');
		if (!targetElement) return;

		const offset = window.innerWidth < 767 ? 100 : 150;
		const elementPosition = targetElement.getBoundingClientRect().top;

		window.scrollTo({
			top: elementPosition - offset,
			behavior: 'smooth',
		});
	});
}


document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("header");
	const main = document.querySelector("main.content");
    const body = document.body;

    const updatePadding = () => {
      if (!header || !main) return;
	  body.style.paddingTop = 0;
      main.style.setProperty("--header-height", header.offsetHeight + "px");
    };

    updatePadding();
    window.addEventListener("resize", updatePadding);
});


class CartUpsell extends HTMLElement {
    constructor() {
		super();
		this.attachShadow({ mode: "open" });
	}

	connectedCallback() {
		this.hasSubscription = this.getAttribute("subscription") === "true";
        this.productId = parseInt(this.getAttribute("product-id"));
		this.itemId = this.getAttribute("item-id");
		this.sellingPlanString = JSON.parse(this.getAttribute("item-selling-plan"));
		this.activeId = String(this.getAttribute("active-subscription")).trim();

		try {
			this.sellingPlans = JSON.parse(this.sellingPlanString);
		} catch (e) {
			console.error("Cannot parse selling plan JSON", e);
			this.sellingPlans = null;
		}

		const variantsToHideSubscriptions = [
			'44917239775466',
			'44920209703146'
		];

		if(variantsToHideSubscriptions.includes(this.itemId)) return;

		this.initCart();


		document.addEventListener('cart:updated', (event) => {
    		this.updateCartData(event.detail);
		});

		this.shadowRoot.addEventListener("click", (e) => {
			if (e.target.matches("button")) {
				this.handleSaveAndSubscribe();
			}
		});

		this.shadowRoot.addEventListener("change", (e) => {
			if (e.target.matches("select")) {
				this.handleSubscriptionChange(e.target.value);
			}
		});
	}

	async initCart() {
		const cartData = await this.fetchCart();
		this.updateCartData(cartData);
	}

	async fetchCart() {
		try {
			const response = await fetch('/cart.js', {
				method: 'GET',
				headers: { 'Content-Type': 'application/json' }
			});
			if (!response.ok) throw new Error('Cannot fetch cart');
			return await response.json();
		} catch (error) {
			console.error(error);
			return { items: [] };
		}
	}

	updateCartData(cart) {
		this.items = Array.isArray(cart.items) ? cart.items : [];
		this.productData = this.items.find(p => p.product_id === this.productId);

		if (!this.productData) return;

		this.groups = (this.sellingPlans || [])
		.filter(group => group.app_id === "5859381")
		.flatMap(group => group.selling_plans);

		const hasAvailablePlans = this.groups.length > 0;

		if(!hasAvailablePlans) return;

		this.firstSellingPlan = this.groups[0].id;

		this.firstPlanSaveValueType = this.groups[0].price_adjustments[0].value_type

		this.firstPlanSaveValue = this.groups[0].price_adjustments[0].value

		this.activePlan = this.groups.find(plan => String(plan.id).trim() === this.activeId);

		this.subscriptions = [
			{ id: '', options_name: 'One-time purchase' },
			...this.groups.map(plan => ({
				id: plan.id,
				name: plan.name,
				options_name: plan.options[0]?.value || '',
			}))
    	];

		this.activeSubscription = this.getAttribute("active-subscription") || this.subscriptions[0].id;

		this.hasSubscription ? this.addSubscriptionDropdown() : this.addSaveAndSubscribeBtn();
	}

	addSaveAndSubscribeBtn () {
		const btn = document.createElement("button");
		let saveValue;
		if (this.firstPlanSaveValueType == 'percentage') {
            saveValue = `${this.firstPlanSaveValue}%`
		} else {
			saveValue = `${this.firstPlanSaveValue}$`
		}

    	btn.textContent = `Subscribe and Save ${saveValue}`;
		btn.classList.add('stay-cart-upsell-btn')
		const style = document.createElement("style");
		style.textContent = `
			.stay-cart-upsell-btn {
				width: 100%;
				padding: 10px;
				border: 1px solid #003452;
            	border-radius: 0.5rem; 
				background: #003452;
				color: #fff;
				font-size: 12px;
			}

			.stay-cart-upsell-btn:hover {
				cursor: pointer;
			}
		`;
    
    	this.shadowRoot.appendChild(style);

		this.shadowRoot.appendChild(btn);
	}

	addSubscriptionDropdown() {
    const wrapper = document.createElement("div");
	
    wrapper.classList.add('stay-cart-upsell-select-wrapper');

    const select = document.createElement("select");
    select.name = "subscription-plan"; 
    select.id = "subscription-plan"; 
    select.classList.add('stay-cart-upsell-select');

    this.subscriptions.forEach(sub => {
        const option = document.createElement("option");
        option.value = sub.id;
        option.textContent = sub.options_name;
        if (sub.id == this.activeSubscription) option.selected = true;
        select.appendChild(option);
    });

    wrapper.appendChild(select);

    const svgIcon = document.createElement("img");
	svgIcon.classList.add('stay-cart-upsell-icon')
    svgIcon.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23003452' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E";
    wrapper.appendChild(svgIcon);

	const style = document.createElement("style");
    style.textContent = `
        .stay-cart-upsell-select-wrapper {
            position: relative;
            width: 100%;
        }

        .stay-cart-upsell-select {
            width: 100%;
            padding: 10px;
            border: 1px solid #003452;
            border-radius: 0.5rem;
            cursor: pointer;
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            background: transparent;
            color: #003452;
            font-size: 12px;
        }

		.stay-cart-upsell-select-wrapper:hover {
			cursor: pointer;
		}

        .stay-cart-upsell-icon {
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
            pointer-events: none;
            width: 16px;
            height: 16px;
        }
    `;
    
    this.shadowRoot.appendChild(style);

    this.shadowRoot.appendChild(wrapper);
}


	handleSubscriptionChange (selectedPlan) {
		const lineKey = this.getAttribute("line-key");
		const quantity = this.getAttribute("quantity");
		const sellingPlan = selectedPlan;

		this.changeSubscription(lineKey, quantity, sellingPlan)
	}

	handleSaveAndSubscribe() {
		const lineKey = this.getAttribute("line-key");
		const quantity = this.getAttribute("quantity");

		this.changeSubscription(lineKey,quantity, this.firstSellingPlan)
	}

	async changeSubscription(lineKey, quantity, sellingPlan) {
		try {
			await S.changeItem({
				id: lineKey,
				quantity: quantity,
				selling_plan: sellingPlan ? parseInt(sellingPlan) : null
			});
			
			await _.dispatch('getCart');

		} catch (error) {
			console.error('Error updating cart:', error);
		}

	}
	
}

customElements.define('cart-upsell', CartUpsell);

class BuyMoreSaveMore extends HTMLElement {
    constructor() {
		super();
		this.attachShadow({ mode: "open" });
	}

	connectedCallback() {
		this.quantity = this.getAttribute('quantity');
		this.lineKey = this.getAttribute('line-key');
		const blocksEl = document.querySelector("#minicart-blocks-data");

		this.blocks = blocksEl 
		? JSON.parse(blocksEl.textContent).blocks || [] 
		: [];


		if (!this.blocks.length) return;

		this.render();

		this.addClickListeners();

		document.addEventListener('cart:updated', (event) => {
			const cartData = event.detail?.cart;

			if (!cartData || !Array.isArray(cartData.items)) return;

			const item = cartData.items.find(i => i.key === this.lineKey);

			if (item) {
				this.quantity = item.quantity;
				this.render();
				this.addClickListeners();
			}
		});
		
	}

	render() {
		const styles = `
		<style>
			.wrapper {
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
				gap: 8px;
				margin-bottom: 18px;
			}

			button {
				background: #003452;
				color: #fff;
				border: none;
				border-radius: 6px;
				padding: 10px;
				cursor: pointer;
				font-size: 12px;
				transition: background 0.2s;
				width: calc(50% - 8px);
			}
				
			button:hover {
				opacity: 0.6;
			}

			.full-width {
				width: 100%;
			}

			.half-width {
				width: calc(50% - 8px);
			}
		</style>
		`;

		const visibleBlocks = this.blocks
		.filter(block => parseInt(block.quantity_value, 10) > parseInt(this.quantity, 10))
		.sort((a, b) => parseInt(a.quantity_value, 10) - parseInt(b.quantity_value, 10));

		if (!visibleBlocks.length) {
			this.shadowRoot.innerHTML = '';
			return;
		}

		const buttons = visibleBlocks
		.map((block, index) => {
			let widthClass = 'half-width';

			if (visibleBlocks.length === 1) widthClass = 'full-width';
			if (visibleBlocks.length === 2) widthClass = 'half-width';
			if (visibleBlocks.length === 3) widthClass = (index < 2) ? 'half-width' : 'full-width';
			if (visibleBlocks.length === 4) widthClass = 'half-width';

			return `<button class='buy_more_btn ${widthClass}' data-id="${block.id}" data-qty="${block.quantity_value}">
				${block.button_label}
			</button>`;
		})
		.join("");


		this.shadowRoot.innerHTML = `
			${styles}
			<div class="wrapper">
			${buttons}
			</div>
		`;
	}

	addClickListeners() {
		this.shadowRoot.querySelectorAll('.buy_more_btn').forEach(btn => {
			btn.addEventListener('click', (e) => this.changeQuantity(e, this.lineKey));
		});
  	}

	async changeQuantity(el, lineKey) {
		const quantity = el.target.dataset.qty;

		try {
			await S.changeItem({
				id: lineKey,
				quantity: quantity
			});
			
			await _.dispatch('getCart');

		} catch (error) {
			console.error('Error updating cart:', error);
		}

	}
	
}

customElements.define('buy-more-save-more', BuyMoreSaveMore);


class DiscountBlock extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.itemObject = null;
    this.discountEl = null;

    window.animatedDiscounts = window.animatedDiscounts || {};
  }

  connectedCallback() {
    const lineItemAttr = this.getAttribute('line-item');

    try {
      this.itemObject = JSON.parse(lineItemAttr);
    } catch {
      this.itemObject = null;
    }

    this.initStyles();

    this.discountEl = document.createElement('p');
    this.discountEl.className = 'discount';
    this.shadowRoot.appendChild(this.discountEl);

    this.render();

    document.addEventListener('cart:updated', (e) => {
		const cartItems = e.detail.cart.items;
		const lineID = this.getAttribute('line-id');

		const cartItem = cartItems.find(item => item.id == lineID);

		if (cartItem) {
			this.itemObject = cartItem;
			this.render();
		} else {
			this.itemObject = null;
			this.discountEl.textContent = '';
			this.discountEl.className = 'discount';
			if (this.discountEl.dataset.discountKey) {
				delete window.animatedDiscounts[this.discountEl.dataset.discountKey];
			}
			delete this.discountEl.dataset.discountKey;
		}
	});
  }

  initStyles() {
    if (!this.shadowRoot.querySelector('style')) {
      const style = document.createElement('style');
      style.textContent = `
        .discount {
          transform: translateX(100%);
          opacity: 0;
          transition: transform 0.5s ease, opacity 0.5s ease;
        }


        .discount.slide-in {
        	transform: translateX(0);
        	opacity: 1;
			display: flex;
			align-items: center;
        }

		.discount.slide-in::before {
			width: 22px;
			height: 20px;
			content: "";
			display: inline-block;
			margin-right: 4px;
			background-image: url('data:image/svg+xml,<svg fill="%23000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 376.08 376.08" xml:space="preserve" stroke="%23000000" stroke-width="0.00376079" transform="rotate(45)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><g><g><g><path d="M306.401,126.975c0-5.918-3.551-14.053-7.891-18.076L195.93,3.015c-4.34-4.02-11.441-4.02-15.78,0.001L77.568,108.899 c-4.34,4.021-7.889,12.156-7.889,18.075l-0.001,238.344c0,5.916,4.843,10.758,10.76,10.76l215.203,0.001 c5.918-0.002,10.76-4.844,10.76-10.763V126.975z M188.413,44.909c12.927,0,23.41,10.479,23.41,23.408 c0,12.93-10.48,23.409-23.41,23.409s-23.409-10.479-23.409-23.409C165.004,55.389,175.484,44.909,188.413,44.909z M271.428,352.565l-166.78-0.001c-5.917,0.001-10.76-4.843-10.76-10.761l-0.001-194.123c0-5.919,4.842-10.761,10.761-10.761 l166.782,0.001c5.918,0,10.76,4.842,10.76,10.759v194.123C282.19,347.723,277.348,352.565,271.428,352.565z"></path></g><g><path d="M180.37,234.079c4.496-4.876,6.973-11.417,6.973-18.418c0-13.332-9.524-26.829-27.728-26.829 c-8.47,0-15.617,2.91-20.668,8.415c-4.473,4.876-6.936,11.415-6.936,18.414c0,13.332,9.482,26.828,27.604,26.828 C168.12,242.489,175.297,239.581,180.37,234.079z M159.615,201.307c9.975,0,14.517,7.445,14.517,14.363 c0,3.763-1.267,7.247-3.567,9.808c-2.569,2.86-6.3,4.373-10.787,4.373c-10.227,0-14.885-7.443-14.885-14.36 C144.893,208.43,149.445,201.307,159.615,201.307z"></path><g><path d="M225.821,199.182c-1.65,0.03-3.902,1.06-5.007,2.285l-82.535,91.765c-1.104,1.228-0.656,2.23,0.994,2.23h11.697 c1.65,0,3.9-1.006,5.001-2.235l82.432-92.075c1.102-1.229,0.65-2.212-0.998-2.182L225.821,199.182z"></path></g><path d="M216.87,252.732c-8.31,0-15.32,2.855-20.274,8.256c-4.388,4.782-6.806,11.197-6.806,18.062 c0,13.078,9.301,26.318,27.08,26.318c8.344,0,15.383-2.854,20.359-8.25c4.41-4.784,6.84-11.2,6.84-18.068 C244.067,265.974,234.726,252.732,216.87,252.732z M217.03,293.292c-9.951,0-14.482-7.47-14.482-14.41 c0-3.778,1.266-7.275,3.563-9.846c2.563-2.87,6.283-4.387,10.757-4.387c9.949,0,14.48,7.471,14.48,14.411 c0,3.777-1.266,7.275-3.562,9.847C225.223,291.775,221.502,293.292,217.03,293.292z"></path></g></g></g></g></svg>');			background-repeat: no-repeat;			
			background-size: contain;
			vertical-align: middle;
		}

        .discount.regular {
          	transform: translateX(0);
          	opacity: 1;
		  	display: flex;
			align-items: center;
        }

		.discount.regular::before {
			width: 22px;
			height: 20px;
			content: "";
			display: inline-block;
			margin-right: 4px;
			background-image: url('data:image/svg+xml,<svg fill="%23000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 376.08 376.08" xml:space="preserve" stroke="%23000000" stroke-width="0.00376079" transform="rotate(45)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><g><g><g><path d="M306.401,126.975c0-5.918-3.551-14.053-7.891-18.076L195.93,3.015c-4.34-4.02-11.441-4.02-15.78,0.001L77.568,108.899 c-4.34,4.021-7.889,12.156-7.889,18.075l-0.001,238.344c0,5.916,4.843,10.758,10.76,10.76l215.203,0.001 c5.918-0.002,10.76-4.844,10.76-10.763V126.975z M188.413,44.909c12.927,0,23.41,10.479,23.41,23.408 c0,12.93-10.48,23.409-23.41,23.409s-23.409-10.479-23.409-23.409C165.004,55.389,175.484,44.909,188.413,44.909z M271.428,352.565l-166.78-0.001c-5.917,0.001-10.76-4.843-10.76-10.761l-0.001-194.123c0-5.919,4.842-10.761,10.761-10.761 l166.782,0.001c5.918,0,10.76,4.842,10.76,10.759v194.123C282.19,347.723,277.348,352.565,271.428,352.565z"></path></g><g><path d="M180.37,234.079c4.496-4.876,6.973-11.417,6.973-18.418c0-13.332-9.524-26.829-27.728-26.829 c-8.47,0-15.617,2.91-20.668,8.415c-4.473,4.876-6.936,11.415-6.936,18.414c0,13.332,9.482,26.828,27.604,26.828 C168.12,242.489,175.297,239.581,180.37,234.079z M159.615,201.307c9.975,0,14.517,7.445,14.517,14.363 c0,3.763-1.267,7.247-3.567,9.808c-2.569,2.86-6.3,4.373-10.787,4.373c-10.227,0-14.885-7.443-14.885-14.36 C144.893,208.43,149.445,201.307,159.615,201.307z"></path><g><path d="M225.821,199.182c-1.65,0.03-3.902,1.06-5.007,2.285l-82.535,91.765c-1.104,1.228-0.656,2.23,0.994,2.23h11.697 c1.65,0,3.9-1.006,5.001-2.235l82.432-92.075c1.102-1.229,0.65-2.212-0.998-2.182L225.821,199.182z"></path></g><path d="M216.87,252.732c-8.31,0-15.32,2.855-20.274,8.256c-4.388,4.782-6.806,11.197-6.806,18.062 c0,13.078,9.301,26.318,27.08,26.318c8.344,0,15.383-2.854,20.359-8.25c4.41-4.784,6.84-11.2,6.84-18.068 C244.067,265.974,234.726,252.732,216.87,252.732z M217.03,293.292c-9.951,0-14.482-7.47-14.482-14.41 c0-3.778,1.266-7.275,3.563-9.846c2.563-2.87,6.283-4.387,10.757-4.387c9.949,0,14.48,7.471,14.48,14.411 c0,3.777-1.266,7.275-3.562,9.847C225.223,291.775,221.502,293.292,217.03,293.292z"></path></g></g></g></g></svg>');			background-repeat: no-repeat;			
			background-size: contain;
			background-repeat: no-repeat;			
			vertical-align: middle;
		}
      `;
      this.shadowRoot.appendChild(style);
    }
  }

  render() {
    if (!this.itemObject) return;
    const discount = this.itemObject.discounts?.[0];
    const lineID = this.getAttribute('line-id');

    if (!discount) {
      if (this.discountEl.dataset.discountKey) {
        delete window.animatedDiscounts[this.discountEl.dataset.discountKey];
      }
      this.discountEl.textContent = '';
      this.discountEl.className = 'discount';
      delete this.discountEl.dataset.discountKey;
      return;
    }

    // Створюємо унікальний ключ: lineID + discountTitle
    const uniqueDiscountKey = `${lineID}_${discount.title}`;
    this.discountEl.dataset.discountKey = uniqueDiscountKey;
    this.discountEl.textContent = discount.title;


    if (window.animatedDiscounts[uniqueDiscountKey]) {
      this.discountEl.className = 'discount regular';
      return;
    }

    this.discountEl.className = 'discount';
    requestAnimationFrame(() => {
      this.discountEl.classList.add('slide-in');
      window.animatedDiscounts[uniqueDiscountKey] = true;
    });
  }
}

customElements.define('discount-block', DiscountBlock);











